import api from "../api";
import utils from "./utils";

export const uploadFile = async ({ file, publicUrl, forWeb }) => {
  const data = new FormData();
  data.append("file", file);

  const res = await api.post("content/upload", false, {
    site: utils.getSite(),
    public: publicUrl,
    forWeb,
    body: data,
  });

  return res;
};

export const uploadLargeFile = async ({ file, publicUrl }) => {
  const { fileUrl, uploadUrl } = await api.post("content/upload/signed", {
    public: publicUrl,
    name: file.name,
  });

  if (!uploadUrl) {
    throw new Error("Unable to upload file");
  }

  const res = await fetch(uploadUrl, {
    method: "PUT",
    body: file,
  });

  if (!res.ok) {
    throw new Error("Error uploading file");
  }

  return {
    status: "ok",
    name: file.name,
    url: publicUrl ? fileUrl : false,
  };
};



// WEBPACK FOOTER //
// ./app/lib/uploads.js